import { combineReducers } from '@reduxjs/toolkit'
import profileReducer from './profile/profile.store'
import appsReducer from './apps'

export const rootReducer = combineReducers({
  profile: profileReducer,
  apps: appsReducer
})
